
import { DeductableMaster, RepairTypeMaster } from './BindMdl';
import { MotorDriverMdl } from './MotorDriverMdl';

export  class mdlBindInfoCompRenewalRes
{
public PolicyNo: string;
public RegNo: string;
public Insured_IdNo: string;
public InsuredName: string;
public VehicleDefType: string;
public SequenceNo: string;
public CustomNo: string;
public deductableList: Array<DeductableMaster>=new Array<DeductableMaster>();
public repairList: Array<RepairTypeMaster>=new Array<RepairTypeMaster>();
public SumInsured:number;
public StatusCode: string;
public ErrorMsg: string;
public DeductableType: string;
public RepairType: number;
public MaxSumInsured: number;
public MinSumInsured: number;
public DriverList :Array<MotorDriverMdl>=new Array<MotorDriverMdl>();   
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlBindInfoCompRenewalRes.ts